import { Injectable } from "@angular/core";
import { ProductActivityRepository } from "../../../../core/repositories";
import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { BaseResponse, ProductActivity } from "../../../../core/domain/models";
import { catchError, map, mergeMap, Observable, reduce } from "rxjs";
import { ProductActivityUrlsEnum } from "./product-activity-urls.enum";
import { ProductActivityWebEntity } from "./product-activity.web-entity";
import { ProductActivityWebRepositoryMapper } from "./product-activity.web-repository-mapper";
import { injectEnvironment } from "master-locations-library/master-locations-library/src/lib/core/environments/environment.token";

@Injectable()
export class ProductActivityWebRepository extends ProductActivityRepository {


  environment = injectEnvironment()

  constructor(private httpClient: HttpClient) {
    super();
  }

  getActivitiesByProduct(productId: string): Observable<ProductActivity[]> {
    const mapper = new ProductActivityWebRepositoryMapper();
    return this.httpClient
      .get<BaseResponse<ProductActivityWebEntity[]>>(`${this.environment.url}${ProductActivityUrlsEnum.GetActivitiesByProduct}`, {
        params: { "productId": productId }
      })
      .pipe(mergeMap((response: BaseResponse<ProductActivityWebEntity[]>) => (response.result)),
        catchError((err: HttpErrorResponse) => {
          throw err;
        }))
      .pipe(map(mapper.mapFrom))
      .pipe(reduce((items: ProductActivity[], item: ProductActivity) => [...items, item], []));
  }
}
